// ============================================================
// src/pages/LoginPage.jsx
// ============================================================
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login }   = useAuth();
  const navigate    = useNavigate();
  const [form, set] = useState({ ee_number: '', password: '', role: 'mechanic' });
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const upd = k => e => set(f => ({ ...f, [k]: e.target.value }));

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!form.ee_number.trim() || !form.password.trim()) {
      setError('Enter your Employee ID and password.');
      return;
    }
    setLoading(true);
    try {
      const user = await login(form.ee_number.trim(), form.password.trim(), form.role);
      navigate(user.role === 'mechanic' ? '/my-timesheet' : '/all-timesheets');
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <div className="login-icon">FC</div>
          <div className="login-header-text">
            <div className="company">Fort Myer Construction Corp.</div>
            <h1>Shop Mechanic<br /><span>Timesheet System</span></h1>
          </div>
        </div>

        <div className="login-body">
          <div className="login-alert">
            <span className="pulse-dot" />
            <span>Network access verification active for mechanics</span>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="field">
              <label className="field-label">Employee ID / EE #<span className="req">*</span></label>
              <input className="inp" type="text" value={form.ee_number}
                onChange={upd('ee_number')} placeholder="e.g. 2411"
                autoComplete="username" disabled={loading} />
            </div>

            <div className="field mt-3">
              <label className="field-label">Password<span className="req">*</span></label>
              <input className="inp" type="password" value={form.password}
                onChange={upd('password')} placeholder="••••••••"
                autoComplete="current-password" disabled={loading} />
            </div>

            <div className="field mt-3">
              <label className="field-label">Login As</label>
              <select className="sel" value={form.role} onChange={upd('role')} disabled={loading}>
                <option value="mechanic">Mechanic</option>
                <option value="supervisor">Supervisor / Admin</option>
              </select>
            </div>

            {error && <div className="login-error mt-3">{error}</div>}

            <div className="login-submit">
              <button type="submit" className="btn btn-primary btn-lg"
                style={{ width: '100%', letterSpacing: '0.1em' }} disabled={loading}>
                {loading ? 'VERIFYING…' : 'ACCESS SYSTEM'}
              </button>
            </div>

            <div className="login-demo mt-3">
              <div><strong>Demo credentials:</strong></div>
              <div>Mechanic: EE# <strong>2411</strong> / Password <strong>Pass123</strong></div>
              <div>Supervisor: EE# <strong>SUP-01</strong> / Password <strong>Admin123</strong></div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
